<div
  class="selector-mapa"
  [class.position-relative]="!useAbsolutePosition"
  [style.background]="backgroundColor"
>
  <irx-segmentado
    class="map-footer-toggle"
    tamano="compacto"
    [value]="tipoMapaBase"
    (change)="cambioDeMapa($event.value)"
  >
    @for (mapa of mapasDisponibles; track mapa.key) {
      <irx-segmento
        [value]="mapa.key"
        [title]="mapa.nombre"
      >
        <img
          [src]="mapa.icono"
          [alt]="mapa.nombre"
          style="width: 15px; height: 15px"
        />
      </irx-segmento>
    }
  </irx-segmentado>
</div>
